import { render } from "./SpacingControl.vue?vue&type=template&id=9675a48a&scoped=true"
import script from "./SpacingControl.vue?vue&type=script&lang=js"
export * from "./SpacingControl.vue?vue&type=script&lang=js"

import "./SpacingControl.vue?vue&type=style&index=0&id=9675a48a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9675a48a"]])

export default __exports__